// link_controller.js
import {Controller} from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    url: String
  }

  connect() {
    this.element.addEventListener('click', this.handleClick.bind(this))
    this.element.addEventListener('contextmenu', this.handleRightClick.bind(this))
    this.element.style.cursor = 'pointer' // Pour indiquer visuellement que l'élément est cliquable
  }

  handleClick(event) {
    event.preventDefault()
    this.openLink(event.ctrlKey)
  }

  handleRightClick(event) {
    event.preventDefault()
    this.openLink(true)
  }

  openLink(newTab = false) {
    const url = decodeURIComponent(window.atob(this.urlValue))

    if (newTab) {
      window.open(url, '_blank')
    } else {
      window.location.href = url
    }
  }
}